import { render } from "./org_admin_Index.vue?vue&type=template&id=6561f7ca&scoped=true"
import script from "./org_admin_Index.vue?vue&type=script&lang=js"
export * from "./org_admin_Index.vue?vue&type=script&lang=js"

import "./org_admin_Index.vue?vue&type=style&index=0&id=6561f7ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6561f7ca"],['__file',"src/layout/org_admin_Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6561f7ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6561f7ca', __exports__)) {
    api.reload('6561f7ca', __exports__)
  }
  
  module.hot.accept("./org_admin_Index.vue?vue&type=template&id=6561f7ca&scoped=true", () => {
    api.rerender('6561f7ca', render)
  })

}


export default __exports__